module.exports = __webpack_public_path__ + "media/icons/float-full-110f5173.svg";